module.exports = require('./EmptySetView');
